import "../../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from '../../prototypes/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/login.template.hbs';
import i18n  from "l10n";


export default GenericView.extend({
    el: "#main",
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: async function (options) {
        this.render();

        this.userHash = options ? options.userHash : null;
        this.type = options ? options.type : null;

        if(this.userHash) {
            if (this.type == 'username')
                await this.verifyUsername();
            else if (this.type == 'email')
                await this.verifyEmail();
        }
	},
	superRender: Backbone.View.prototype.render,
	render: function () {
		this.superRender();

		this.$el.html(this.template());
	},
	events:{
		"click #loginButton": "login",
		"submit #form": "login",
		"click .togglePasswordType": "togglePassWordViewable",
        "click #facebook": "facebookAuth",
        "click #google": "googleAuth"
	},
	login: function(e) {
        e.preventDefault();

		var self = this;

        var data = {
            "username": $("#username").val(),
            "password": $("#password").val()
        };

        var $elem = this.$el.find("#loginButton");

        $elem.prop("disabled", true);

        //$.when(window.ping()).then(function(resp) {
        $.when(true).then(function(resp) {
            $.ajaxDefaultQ({
                url: window.ip+'/rest/auth/login',
                type: 'POST',
                data: JSON.stringify(data),
                contentType : 'application/json',
                beforeSend: function (xhr) {
                    //xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                }
            }).done(function(response, status, xhr){

                if(status == "success") {
                    window.open('store.html','_self');
                }
                else {

                }

                $elem.prop("disabled", false);
            })
            .fail(function(error) {
                var errorMsg = "";
                var statusCode = error.status;
                var systemErrorCode = error.responseJSON && error.responseJSON.error && error.responseJSON.error.exception && error.responseJSON.error.exception.code ? error.responseJSON.error.exception.code : -1;

                if(statusCode == 406 && systemErrorCode == "2-2-5")
                    errorMsg = i18n.t("user.already_logged_in");
                else if(statusCode == 502)
                     errorMsg = i18n.t("server.is_down");
                else
                    errorMsg = i18n.t("account.check_credentials");

                $elem.notify(errorMsg, { position:"bottom center", className: "error"});

                document.cookie = "status=0";

                $elem.prop("disabled", false);
            });
        });

		return false;
	},
	loginWithEnter: function(event)
	{

	 	event.preventDefault();
        if (event.keyCode == 13) {
        	if($("#username").val() != "" && $("#password").val() != null)
           	 	this.login();
        }
	},
	verifyUsername: function() {
	    var self = this;

        return $.ajaxDefaultQ({
            url: window.ip+'/rest/auth/username/' + this.userHash,
            type: 'POST',
        }).done(function(response, status, xhr){
             $.notify(i18n.t("account.username_success_change"), { position:"top center", className: "success"});
        })
        .fail(function(response) {
            $.notify(i18n.t("account.sth_wrong_"), { position:"top center", className: "success"});
        })
	},
	verifyEmail: function() {
        var self = this;

        return $.ajaxDefaultQ({
            url: window.ip+'/rest/auth/email/' + this.userHash,
            type: 'POST',
        }).done(function(response, status, xhr){
             $.notify(i18n.t("account.email_success_change"), { position:"top center", className: "success"});
        })
        .fail(function(response) {
            $.notify(i18n.t("account.sth_wrong_"), { position:"top center", className: "success"});
        })
    },
    togglePassWordViewable: function (event) {
        this.togglePassWordViewableGeneric(event);
    },
    facebookAuth: function (e) {
        e.preventDefault();
        this.facebookAuthOpenDialog();
    },
    googleAuth: function (e) {
        e.preventDefault();
        this.googleAuthOpenDialog();
    }
});
